/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/yubashuo/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var common=__webpack_require__(2);
	
	window.requestAnimFrame = (function () {
	    return window.requestAnimationFrame ||
	        window.webkitRequestAnimationFrame ||
	        window.mozRequestAnimationFrame ||
	        function (callback) {
	            window.setTimeout(callback, 1000 / 60);
	        };
	})();
	
	Handlebars.registerHelper("color",function(index){
		var t=index%5;
		return colorList[t];
	});
	
	Handlebars.registerHelper("fontSize",function(txt){
		if(txt.length<=7){
			return "bigFont";
		}
		return "";
	});
	var defaultImg=getAbsoluteUrl(__webpack_require__(3));
	Handlebars.registerHelper("head",function(imgKey){
		if(imgKey){
			return imgKey;
		}
		return defaultImg;
	});
	
	function getAbsoluteUrl (url) {
	    var a = document.createElement('a');
	    a.href = url;
	    return a.href;
	}
	
	var Bullet=__webpack_require__(4);
	var comment=__webpack_require__(5);
	var Toast=__webpack_require__(1);
	var myScroll;
	var originImgWidth=750;
	var originImgHeight=360;    
	var bulletScreenHeight=$(".bulletScreen").height();
	var bulletScreenWidth=$(".bulletScreen").width();
	var fixHeight=bulletScreenWidth/originImgWidth*originImgHeight;
	var docEl = document.documentElement;
	var fontSize=docEl.style.fontSize;
	var gutter=parseInt(fontSize.substr(0,fontSize.length-2))*0.3;
	var colorList=[
		"#f09e28","#95a6aa","#ebc42a","#f34f4f","#80b4b5","#f39c12"
	]
	
	var $grid;
	function loaded () {
		$grid=$('.itemList').masonry({
		  itemSelector: '.item',
		  gutter:gutter
		});
		myScroll = new IScroll('.scrollWrap', { mouseWheel: true ,probeType:3,click:true});
		myScroll.on("scroll",function(){
			if(this.y>fixHeight-bulletScreenHeight){
				$(".bulletScreen").height(this.y+bulletScreenHeight);
				$(".bulletScreen").css({top:0});
			}else{
				$(".bulletScreen").css({top:this.y-fixHeight+bulletScreenHeight});
			}	
			if(this.y<-435/640*bulletScreenWidth){
				$(".tips").hide();
			}else{
				$(".tips").show();
			}
			if(typeof(InnerJSHelper)!="undefined"){
				InnerJSHelper.onScroll(this.y);
			}		
		})
		myScroll.on('scrollEnd', function () {				
		    if ( this.y <=this.maxScrollY) {
		    	main.getCommentList();	        
		    }
		});
	
		var touchEndPosY=0;
		$(window).bind("touchend",function(){
			touchEndPosY=myScroll.y;
		})
		myScroll.on('scrollEnd', function () {	
		    if ( touchEndPosY >=40){
		    	// window.location.reload();
		    }
		});
	
	}
	loaded();
	
	var canvas = document.querySelector("canvas");
	var scale=window.devicePixelRatio;
	var shareWidth=$(".m-share").width();
	var shareHeight=$(".m-share").height();
	TweenMax.set($(".m-share"),{scaleX:scale,scaleY:scale,left:0,top:0,transformOrigin:'left top'});
	$("canvas").attr("width",shareWidth*scale);
	$("canvas").attr("height",shareHeight*scale);
	var tycredidential=common.getQueryString("tycredidential");
	var bulletList=[];
	window.main={
		trajectoryCount:6,
		bulletIndex:0,
		commentOffset:0,
		limit:29,
		itemsListEl:$(".itemList"),
		init:function(){	
			var _this=this;		
			
			if(commentCount>=0){
				this.getBulletList();
			}		
			this.getCommentList();
			this.initEvent();
			if(typeof(CommonJSHelper)=="undefined" && typeof(window.webkit) == "undefined"){
				$(".m-bottomBar").hide();
				$(".m-topic").css({"bottom":"0","top":"1rem"});
				$(".m-topbar").show();
			}
			$(".commentBtn").click(function(){
				if(!isLogined){
					common.login();
					return;
				}
				if(canCommentCount<=0){
					var t=new Toast("今天小主已经表达很深刻了，明天再来吧~");
					return;
				}
				comment.show();
			})
	
			$(".backBtn").click(function(){
				common.closePage();
			})
	
			$(".shareBtn").click(function(){
				var title="【天谕话题】"+$(this).data("title");
				var desc=$(this).data("desc");
				var img=$(this).data("img");
				var url=window.location.protocol+"//"+window.location.host+window.location.pathname+"?topicId="+topicId;
				CommonJSHelper.shareWithImageTitleDespUrlTopicId(img,title,desc,url,topicId);
			})
	
		},
		initEvent:function(){
			var _this=this;
			this.itemsListEl.delegate('.zanBtn', 'click', function(){
				var id=$(this).data("id");
				var hasZan=$(this).attr("data-haszan");
				if(hasZan=="1"){
					_this.zan(id,0);
				}else{
					_this.zan(id,1);
				}			
			});
	
			this.itemsListEl.delegate('.shareBtn','click',function(){
				var nickname=$(this).data("nickname");
				var content=$(this).data("content");
				var headimg=$(this).data("headimg");
				var zan=$(this).data("zan");
				var color=$(this).data("color");
				var id=$(this).data("id");
				var bigFontClass=false;
				if($(this).hasClass("bigFont")){
					bigFontClass=true;
				}
				_this.share(nickname,content,headimg,zan,color,id,bigFontClass);
			})
	
			this.itemsListEl.delegate('.mySpaceBtn','click',function(){
				var id=$(this).data("playid");
				CommonJSHelper.showPersonalPageByURS(id);
			})
			$(".bulletScreen,.tips,.m-bottomBar").bind("touchmove",function(e){
				e.preventDefault();
				e.stopPropagation();
			})		
	
		},
		zan:function(id,type){
			var _this=this;
			// $.getJSON("/yubashuo/zan-comment?commentId="+id+"&type="+type+"&tycredidential="+tycredidential,function(msg){
				
			// })
			$.ajax({
			    url:'/yubashuo/zan-comment',
			    type:'POST',
			    data:{
			        commentId:id,
			        type:type,
			        tycredidential:tycredidential
			    },
			    dataType:'json',
			    success:function(msg){
			    	if(msg.resCode==11){
			    		common.login();
			    		return;
			    	}
			        if(msg.resCode!=0){
						alert(msg.resReason);
						return;
					}
					if(type==0){
						var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
						num=parseInt(num);
						num--;
						$(".zanBtn[data-id="+id+"]").find(".num").html(num);
						$(".zanBtn[data-id="+id+"]").find(".icon-zan").removeClass("icon-zan-1");
						$(".zanBtn[data-id="+id+"]").attr("data-haszan","0");
						$(".bullet[data-id="+id+"]").removeClass("active");
					}
					if(type==1){
						var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
						num=parseInt(num);
						num++;
						$(".zanBtn[data-id="+id+"]").find(".num").html(num);
						$(".zanBtn[data-id="+id+"]").find(".icon-zan").addClass("icon-zan-1");
						$(".zanBtn[data-id="+id+"]").attr("data-haszan","1");
						$(".bullet[data-id="+id+"]").addClass("active");
					}
					_this.changeZan(id,type);
			    },
			    error:function(){
			    	new Toast("网络不可用，请稍后再试！");
			    }
			})
		},
		changeZan:function(id,type){
			for(var i=0;i<bulletList.length;i++){
				if(bulletList[i].commentId==id){
					bulletList[i].hasZan=type;
					break;
				}
			}
		},
		addNewComment:function(html){
			$(".commentBtn.item").after(html);
			$grid.masonry('destroy');
			$grid=$('.itemList').masonry({
				itemSelector: '.item',
				gutter:gutter
			});			
			myScroll.refresh();
		},
		share:function(nickname,content,headimg,zan,color,id,bigFontClass){	
			$(".m-share").show();
			var c="";
			var l=10;
			if(content.length>10){
				for(var i=0;i<content.length;i+=10){
					c+=content.substr(i,10)+"<br>";
				}
				$(".m-share .info").html(c);
			}else{
				$(".m-share .info").html(content);
			}				
			$(".m-share .count").html(zan);
			// $(".m-share .headImg").attr("src",headimg);
			$(".m-share .author").html("by "+nickname);
			$(".m-share .bgColor").css({"background":color});
			if(bigFontClass){
				$(".m-share .info").addClass("bigFont");
			}else{
				$(".m-share .info").removeClass("bigFont");
			}
			html2canvas(document.querySelector(".m-share"), {
				canvas: canvas,
				useCORS:true,
				letterRendering:true
			}).then(function(canvas) {	        
				var url=window.location.protocol+"//"+window.location.host+window.location.pathname+"?topicId="+topicId;
		        var qrcode	= new QRCode(-1, 1);
				qrcode.addData(url);
				qrcode.make();
	
				var options	= $.extend( {}, {
					render		: "canvas",
					width		: 256,
					height		: 256,
					typeNumber	: -1,
					correctLevel	: QRErrorCorrectLevel.H,
		                        background      : "#ffffff",
		                        foreground      : "#000000"
				}, options);
	
				// create canvas element
				var canvas	=$("canvas")[0];
				var ctx		= canvas.getContext('2d');
				options.width=84/640*canvas.width;
				options.height=84/640*canvas.width;
				// compute tileW/tileH based on options.width/options.height
				var tileW	= options.width  / qrcode.getModuleCount();
				var tileH	= options.height / qrcode.getModuleCount();
				var startX=canvas.width-100/640*canvas.width;
				var startY=canvas.height-100/820*canvas.height;
				// draw in the canvas
				for( var row = 0; row < qrcode.getModuleCount(); row++ ){
					for( var col = 0; col < qrcode.getModuleCount(); col++ ){
						ctx.fillStyle = qrcode.isDark(row, col) ? options.foreground : options.background;
						var w = (Math.ceil((col+1)*tileW) - Math.floor(col*tileW));
						var h = (Math.ceil((row+1)*tileW) - Math.floor(row*tileW));
						ctx.fillRect(startX+Math.round(col*tileW),startY+Math.round(row*tileH), w, h);  
					}	
				}
	
				var myImage = canvas.toDataURL("image/png");
		        var url=window.location.protocol+"//"+window.location.host+window.location.pathname+"?topicId="+topicId;
		        var desc=topicTitle+url;
		        CommonJSHelper.shareImageWithCommentId(myImage,desc,id);
		        // window.open(myImage);
		        $(".m-share").hide();
		    });
		},
		getBulletList:function(){
			var _this=this;
			// get-bullet-comment-list
			if(typeof(CommonJSHelper)=="undefined"){
				return;
			}
			$.getJSON("/yubashuo/get-bullet-comment-list?topicId="+topicId+"&offset=0&limit=100&tycredidential="+tycredidential,function(msg){
				if(msg.resCode!=0||!msg.data){
					return;
				}
				bulletList=msg.data;
				for(var i=0;i<_this.trajectoryCount;i++){
					_this.addNewBullet(i);
					_this.getBulletIndex();
				}
			})
		},
		getCommentList:function(){
			var _this=this;
			if(this.commentOffset>commentCount-1){
				return;
			}
			$.getJSON("/yubashuo/get-comment-list?topicId="+topicId+"&offset="+this.commentOffset+"&limit="+this.limit+"&tycredidential="+tycredidential,function(msg){
				if(msg.resCode!=0){
					console.log(msg.resReason);
					return;
				}
				var source=$("#commentItem-template").html();
				var template=Handlebars.compile(source);
				var html=template({items:msg.data});
				$(".itemList").append(html);
				$grid.masonry('destroy');
				$grid=$('.itemList').masonry({
					itemSelector: '.item',
					gutter:gutter
				});			
				myScroll.refresh();
				if(msg.data){
					_this.commentOffset+=msg.data.length;
				}	
				_this.limit=20;	
			})
		},
		addNewBullet:function(trajectory){
			var b=new Bullet(bulletList[this.bulletIndex],trajectory);
			this.getBulletIndex();
		},
		getBulletIndex:function(){
			if(this.bulletIndex==bulletList.length-1){
				return this.bulletIndex=0;
			}else{
				return this.bulletIndex++;
			}
		}
	}
	main.init();
	comment.init();
	
	
	


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	function Toast(txt){
		this.el=$("<p class='toast'>"+txt+"</p>");
		$(".m-toast").append(this.el);
		this.show();
	}
	
	Toast.prototype.show=function(){
		var _this=this;
		var width=this.el.outerWidth();
		var height=this.el.outerHeight();
		var windowWidth=$(".g-wrap").width();
		var windowHeith=$(window).height();
		TweenMax.set(this.el,{alpha:0,left:windowWidth/2-width/2,top:windowHeith/2-height/2,marginTop:"0.2rem"});
		TweenMax.to(this.el,0.3,{alpha:1,marginTop:0});
		TweenMax.to(this.el,0.3,{alpha:0,delay:1.7,marginTop:"-0.2rem",onComplete:function(){
			_this.destroy();
		}});
	}
	
	Toast.prototype.destroy=function(){
		TweenMax.killTweensOf(this.el);
		this.el.remove();
		this.el=null;
	}
	
	module.exports=Toast;
	


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	var common={
		getQueryString:function(name){
			var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		    var r = window.location.search.substr(1).match(reg);
		    if(r!=null)return  unescape(r[2]); return null;
		},
		login:function(){
			if(this.getQueryString("tycredidential")!=null&&this.getQueryString("tycredidential")!=""){
				CommonJSHelper.tyInvalid()
			}else{
				CommonJSHelper.login();
			}
		},
		closePage:function() {
				if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.closePage) {
					window.webkit.messageHandlers.closePage.postMessage(1)
				} else if (typeof CommonJSHelper !== 'undefined') {
					CommonJSHelper.closePage()
				}
		},
		showUrlInNewpage:function(url) {
			if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.showUrlInNewpage) {
				window.webkit.messageHandlers.showUrlInNewpage.postMessage(url)
			} else if (typeof CommonJSHelper !== 'undefined') {
				CommonJSHelper.showUrlInNewpage(url)
			}
		}
	}
	
	module.exports=common;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "14320c7d07db44c115a7650cb86a20f7.png";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var defaultImg=getAbsoluteUrl(__webpack_require__(3));
	function getAbsoluteUrl (url) {
	    var a = document.createElement('a');
	    a.href = url;
	    return a.href;
	}
	function Bullet(obj,trajectory){
		var _this=this;
		this.trajectory=trajectory;
		this.txt=obj.content;
		var activeClass="";
		if(obj.hasZan==1){
			activeClass="active";
		}
		if(obj.headImgKey){
			this.$el=$('<span class="bullet '+activeClass+'" data-id="'+obj.commentId+'"><span class="icon-zan"></span><img src="'+obj.headImgKey+'">'+obj.content+'</span>');
		}else{
			this.$el=$('<span class="bullet '+activeClass+'" data-id="'+obj.commentId+'"><span class="icon-zan"></span><img src="'+defaultImg+'">'+obj.content+'</span>');
		}	
		this.$el.css("left",this.startPosX);
		$(".bulletScreen").append(this.$el);
		this.w=this.$el.outerWidth();
		this.containerWidth=$(".g-wrap").width();
		this.speed=this.w/7+this.containerWidth/7;
		this.init();
		this.animate();
		this.isTrigger=false;
		this.$el.click(function(){		
			if($(this).hasClass("active")){
				$(this).removeClass("active");
				// _this.zan(obj.commentId,0);
				window.main.zan(obj.commentId,0);
			}else{
				$(this).addClass("active");
				// _this.zan(obj.commentId,1);
				window.main.zan(obj.commentId,1);
			}
		})
	}
	
	// Bullet.prototype.zan=function(id,type){
	// 	$.getJSON("/yubashuo/zan-comment?commentId="+id+"&type="+type,function(msg){
	// 		if(msg.resCode!=0){
	// 			alert(msg.resReason);
	// 			return;
	// 		}
	// 		if(type==0){
	// 			var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
	// 			num=parseInt(num);
	// 			num--;
	// 			$(".zanBtn[data-id="+id+"]").find(".num").html(num);
	// 			$(".zanBtn[data-id="+id+"]").find(".icon-zan").removeClass("icon-zan-1");
	// 			$(".zanBtn[data-id="+id+"]").attr("data-haszan","0");
	// 		}
	// 		if(type==1){
	// 			var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
	// 			num=parseInt(num);
	// 			num++;
	// 			$(".zanBtn[data-id="+id+"]").find(".num").html(num);
	// 			$(".zanBtn[data-id="+id+"]").find(".icon-zan").addClass("icon-zan-1");
	// 			$(".zanBtn[data-id="+id+"]").attr("data-haszan","1");
	// 		}
	// 	})
	// }
	
	Bullet.prototype.init=function(){
		var txtLength=this.txt.length;
		var space=txtLength*10;
		this.left=this.containerWidth+space;
		this.time=7/(this.containerWidth+this.w)*(this.left+this.w);
		TweenMax.set(this.$el,{left:this.left,top:this.trajectory*60/100+60/100+"rem"});
	}
	
	Bullet.prototype.animate=function(){
		var width=this.$el.outerWidth()
		var _this=this;
		TweenMax.to(this.$el,this.time,{left:-width,ease:Power0.easeNone,onComplete:function(){
			_this.destroy();
		},onUpdate:function(){
			if(_this.isTrigger){
				return;
			}
			var left=_this.$el.css("left");
			left=parseInt(left.substr(0,left.length-2));
			var endX=_this.w+left;
			if(endX<_this.containerWidth){
				_this.isTrigger=true;
				window.main.addNewBullet(_this.trajectory);
			}		
		}});
	}
	
	Bullet.prototype.update=function(){
		var x=this.$el.css("left");
		x-=this.speed;
		this.$el.css("left",x);
	}
	
	Bullet.prototype.destroy=function(){
		TweenMax.killTweensOf(this.$el);
		this.$el.remove();
		this.$el=null;
	}
	
	module.exports=Bullet;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var common=__webpack_require__(2);
	var Toast=__webpack_require__(1);
	var tycredidential=common.getQueryString("tycredidential");
	var comment={
		el:$(".m-comment"),
		topicId:topicId,
		init:function(){
			var _this=this;
			this.el.find(".closeBtn").click(function(){
				_this.hide();
			})
	
			this.el.find("#commentTextArea").bind("input",function(){
				var count=$(this).val().length;
				_this.el.find(".limit").html(count+"/50");
			})
			this.el.find(".submitBtn").click(function(){
				_this.submit();
			})
		},
		submit:function(){
			var _this=this;
			var content=this.el.find("#commentTextArea").val();
			content=$.trim(content);
			if(content.length==0){
				new Toast("请输入回复内容");
				return;
			}
			// $.getJSON("/yubashuo/add-comment?topicId="+this.topicId+"&content="+encodeURIComponent(content)+"&tycredidential="+tycredidential,function(msg){
				
			// })
			$.ajax({
			    url:'/yubashuo/add-comment',
			    type:'POST',
			    data:{
			        topicId:this.topicId,
			        content:content,
			        tycredidential:tycredidential
			    },
			    dataType:'json',
			    success:function(msg){
			    	if(msg.resCode==11){
			    		common.login();
			    		return;
			    	}
			        if(msg.resCode!=0){
						new Toast(msg.resReason);
						return;
					}
					_this.hide();
					var source=$("#commentItem-template").html();
					var template=Handlebars.compile(source);
					var html=template({items:[msg.data]});
					window.main.addNewComment(html);
					canCommentCount--;
			    },
			    error:function(){
			    	new Toast("网络不可用，请稍后再试！");
			    }
			})
		},
		show:function(){
			$(".m-share").hide();
			$(".m-topic").hide();
			$(".m-bottomBar").hide();
			$("canvas").hide();
			this.el.show();	
			this.el.find("#commentTextArea").val("");
		},
		hide:function(){
			$(".m-topic").show();
			$(".m-bottomBar").show();
			this.el.hide();		
			this.el.find(".limit").html("0/50");		
		}
	}
	module.exports=comment;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// topic.js